module.exports = __webpack_public_path__ + "img/card_14.d2e2469e.png";